import { render, staticRenderFns } from "./MultiplierCard.vue?vue&type=template&id=0a005c48&scoped=true"
import script from "./MultiplierCard.vue?vue&type=script&lang=js"
export * from "./MultiplierCard.vue?vue&type=script&lang=js"
import style0 from "./MultiplierCard.vue?vue&type=style&index=0&id=0a005c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a005c48",
  null
  
)

export default component.exports